import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import LoadingInForm from '../../components/LoadingInForm';
import AlertError from '../../components/AlertError';
import api from '../../services/api';
import { STRINGS } from '../../util/strings';
import { CadernoLPMA as CadernoLPMAType } from '../../models/modelsCadernoLPMA';
import CadernoLPMAForm from './Add';

const EditCadernoLPMA: React.FC = () => {
	const params = useParams<Record<string, string | undefined>>();
	const id = params.id;
	const [loading, setLoading] = useState<boolean>(true);
	const [errorMessages, setErrorMessages] = useState<string[] | null>(null);
	const [entity, setEntity] = useState<CadernoLPMAType | undefined>(undefined);

	useEffect(() => {
		const fetchData = async () => {
			if (!id) {
				setErrorMessages([STRINGS.ALERT_GENERIC_ERROR]);
				setLoading(false);
				return;
			}

			setLoading(true);
			setErrorMessages(null);

			try {
				const response = await api.get<CadernoLPMAType>(`api/v1/cadernoLPMA/CadernoLPMA/${id}`);
				if (response.status === 200) {
					setEntity(response.data);
				} else {
					setErrorMessages([STRINGS.ALERT_GENERIC_ERROR]);
				}
			} catch (err: any) {
				const status = err?.response?.status;
				if (status === 403) {
					setErrorMessages(['Sem permissão para visualizar este caderno LPMA.']);
				} else {
					const payload = err?.response?.data;
					if (payload?.message?.length) {
						setErrorMessages(Array.isArray(payload.message) ? payload.message : [payload.message]);
					} else {
						setErrorMessages([STRINGS.ALERT_GENERIC_ERROR]);
					}
				}
			} finally {
				setLoading(false);
			}
		};

		fetchData();
	}, [id]);

	if (loading) {
		return <LoadingInForm />;
	}

	if (errorMessages) {
		return (
			<div className="container container-fluid">
				{errorMessages.map((message, index) => (
					<AlertError key={`${message}-${index}`} message={message} />
				))}
			</div>
		);
	}

	if (!entity) {
		return (
			<div className="container container-fluid">
				<AlertError message={STRINGS.ALERT_GENERIC_ERROR} />
			</div>
		);
	}

	return <CadernoLPMAForm key={entity.id ?? 'edit-form'} initialEntity={entity} mode="edit" />;
};

export default EditCadernoLPMA;

